import React from 'react';
import classNames from 'classnames';
import styles from '../CaseDetails.module.scss';
import { IGovernmentCaseNumber } from 'src/shared/types/Case';
import { CountryCode } from 'src/utils/constants/common';

const EGOV_LINK = 'https://egov.uscis.gov/';

const showUSCISLink = (caseCountryCode: string, governmentCaseNumber: string) =>
  caseCountryCode === CountryCode.UnitedStates && /^[A-Za-z]{3}\d{1,}/.test(governmentCaseNumber);

interface IGovernmentCaseNumbers {
  governmentCaseNumbers?: IGovernmentCaseNumber[];
  caseCountryCode?: string;
}

export const GovernmentCaseNumbers = ({ governmentCaseNumbers, caseCountryCode = '' }: IGovernmentCaseNumbers) => {
  return (
    <div className={classNames(styles['case-content'], styles['government-case-numbers'])}>
      <span className={styles['info-label']}>Government Case Numbers</span>
      <div className={styles['info-value']}>
        {governmentCaseNumbers?.map(({ fullName, governmentCaseNumber }, index) => (
          <div key={`${governmentCaseNumber}-${index}`} className={styles['government-case-number-container']}>
            <span className={styles['government-case-right-spacing']}>{fullName} -</span>
            {showUSCISLink(caseCountryCode, governmentCaseNumber) ? (
              <a className={styles['case-number-link']} href={EGOV_LINK} target="_blank" rel="noopener noreferrer">
                {governmentCaseNumber}
              </a>
            ) : (
              <span>{governmentCaseNumber}</span>
            )}
            {index !== governmentCaseNumbers.length - 1 && (
              <span className={styles['government-case-right-spacing']}>,</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(GovernmentCaseNumbers);
